﻿import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from "classnames";
import { Intent, NonIdealState } from "@blueprintjs/core";
import { Button } from 'components/buttons';
import { ShowHide } from 'components/layout/ShowHide';
import 'components/listing/Listing.css';
import { Table } from 'components/listing';

const defaultArray = [];

export function EditTable(
    {
        data = defaultArray,
        headerData = {},
        loadingData = false,
        fitToContent = false,
        onAddRowClick = () => null,
        onEditRowClick = () => null,
        onDeleteRowClick = () => null,
        canAddRows = false,
        canDeleteRows = false,
        canEditAllRows = false,
        disabled = false,
        noDateMessage = '',
        noDataHeading = 'Nothing to see here...',
        noDataMessage
    }
) {
    const [numberOfEditButtons, setNumberOfEditButtons] = useState(0);

    useEffect(() => {
        let numberOfButtons = 0;

        if ((data?.some(row => row.isEditable)) || canEditAllRows) {
            numberOfButtons++;
        }

        if (canAddRows) {
            numberOfButtons++;
        }

        if (canDeleteRows) {
            numberOfButtons++;
        }

        setNumberOfEditButtons(numberOfButtons);
    }, [canAddRows, data, canDeleteRows, canEditAllRows]);

    function renderEditButtonsHeader() {
        return (
            <Fragment>
                <th className={classNames('listing-table-button-header hide-in-print', `listing-table-button-header-${numberOfEditButtons}`)}>
                    {canAddRows && <Button icon='plus' minimal={true} intent={Intent.NONE} onClick={() => onAddRowClick(-1)} disabled={disabled}></Button>}
                </th>
            </Fragment>
        );
    }

    function renderRowButtons(row, rowIndex) {
        return (
            <ShowHide
                evaluator={numberOfEditButtons > 0}
                show={<Fragment>
                    <td className='listing-table-buttons hide-in-print'>
                        <ShowHide
                            evaluator={canAddRows}
                            show={
                                <Button icon='plus' minimal={true} intent={Intent.NONE} onClick={() => onAddRowClick(rowIndex)} disabled={disabled}></Button>
                            }
                        />
                        <ShowHide
                            evaluator={canEditAllRows || row.isEditable}
                            show={
                                <Button icon='edit' minimal={true} intent={Intent.NONE} onClick={() => onEditRowClick(rowIndex)} disabled={disabled}></Button>
                            }
                        />
                        <ShowHide
                            evaluator={canDeleteRows}
                            show={
                                <Button icon='trash' minimal={true} intent={Intent.NONE} onClick={() => onDeleteRowClick(rowIndex)} disabled={disabled}></Button>
                            }
                        />
                    </td>
                    <td className='listing-table-validity'>{row.validity}</td>
                </Fragment>}
            />
        );
    }

    function formatData() {
        return data.map((row, rowIndex) => {
            return {
                key: row.key,
                cells: row.cells,
                additionalCells: renderRowButtons(row, rowIndex),
                class: row.valid === false && !disabled ? "table-row-invalid" : ""
            };
        });
    }

    function formatHeaderData() {
        return {
            ...headerData,
            additionalHeaders: renderEditButtonsHeader()
        };
    }

    return (
        <ShowHide
            evaluator={data.length === 0 && !canAddRows && !loadingData}
            show={(
                <Fragment>
                    <div className="clear-divide"></div>
                    <div className="list-table-no-results">
                        <NonIdealState                            
                            title={noDataHeading}
                            description={noDataMessage}
                        />
                    </div>
                </Fragment>

            )}
            hide={(
                <Table
                    data={formatData()}
                    headerData={formatHeaderData()}
                    loadingData={loadingData}
                    fitToContent={fitToContent}
                />
            )}
        />
    );
}

EditTable.propTypes = {
    data: PropTypes.array.isRequired,
    headerData: PropTypes.object,
    loadingData: PropTypes.bool,
    fitToContent: PropTypes.bool,
    onAddRowClick: PropTypes.func,
    onEditRowClick: PropTypes.func,
    onDeleteRowClick: PropTypes.func,
    canAddRows: PropTypes.bool,
    canDeleteRows: PropTypes.bool,
    canEditAllRows: PropTypes.bool,
    disabled: PropTypes.bool,
    noDataMessage: PropTypes.string,
    noDataHeading: PropTypes.string,
};
